const setLang = (state,lang) => {
	state.i18n.locale = lang;
}

export default{
    setLang
}